import { createContext, useContext, useEffect, useState } from 'react';
import apiService from '../Configurations/APIService';
import config from '../Configurations/APIConfig';
import { LandingContext } from '../../Components/Profile/LandingContext';
import CompanyTemplates from '../../CompanyData/CompanyTemplates';
import DefaultData from '../../CompanyData/DefaultData';
const TenantContext = createContext(null);

const safeJSON = (str, fallback = {}) => {
  if (!str || str === 'string' || str === 'null') return fallback;
  try { return JSON.parse(str); } catch { return fallback; }
};

const extractDomain = () => {
  let host = window.location.hostname.toLowerCase();
  if (host.startsWith('www.')) host = host.replace('www.', '');
  return host;
};

export const TenantProvider = ({ children }) => {
  const [tenantData, setTenantData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTenantData = async () => {
      const params = new URLSearchParams(window.location.search);
      const urlTemplate = params.get('template');
      const domain = extractDomain();

      if (urlTemplate) {
        sessionStorage.setItem('preview_template', urlTemplate);
      }
      const previewTemplate = urlTemplate || sessionStorage.getItem('preview_template');

      const isGenericPreview = !!previewTemplate;

      if (isGenericPreview) {
        setTenantData({

          templateReference: previewTemplate,
          isPreview: true,
          companyId: DefaultData.DEFAULTCOMPANYID, 
          branding: {}, theme: {}, header: [], hero: {}, footer: {},
          aboutUs: {}, contactUs: {}, seo: {}, destinations: [],
          activeModules: {}, layout: {}
        });
        setLoading(false);
        return;
      }

      try {        
        /* const activeDomain = domain === 'localhost' ? 'airve.in' : domain;
        const res = await apiService.getAll(`${config.GETTEMPLATEBYDOMAIN}/${activeDomain}`);
        const data = res.data || res; */
        const activeDomain = domain === 'localhost' ? 'airve.in' : domain;
        const data = CompanyTemplates.find(
          x => x.domain?.toLowerCase() === activeDomain.toLowerCase()
        );
        sessionStorage.removeItem('preview_template'); 

        setTenantData({
          companyId:         data.companyId,
          branchId:          data.branchId, 
          userId:            data.userId, 
          templateId:        data.templateId,
          domain:            data.domain,
          // Priority: URL/Session Preview -> Database -> null (instead of Template_1)
          templateReference: previewTemplate || data.templateReference || data.templateRefference || null,
          branding:      safeJSON(data.customBrandingJson, {}),
          theme:         safeJSON(data.styleJson, {}),
          header:        safeJSON(data.headerJson, []),
          topBar:        safeJSON(data.topBarJson, {}), 
          hero:          safeJSON(data.heroJson, {}),
          footer:        safeJSON(data.footerJson, {}),
          aboutUs:       safeJSON(data.aboutUsJson, {}),
          contactUs:     safeJSON(data.contactUsJson, {}),
          faq:           safeJSON(data.faqJson, {}),
          terms:           safeJSON(data.termsAndConditionsJson, {}),
          privacyPolicy:   safeJSON(data.privacyPolicyJson, {}),
          refundPolicy:    safeJSON(data.refundPolicyJson, {}),
          seo:           safeJSON(data.seoJson, {}),
          destinations:  safeJSON(data.destinationsJson, { destinations: [] }).destinations || [],
          activeModules: safeJSON(data.activeModulesJson, {}),
          layout:        safeJSON(data.layoutJson, {}),
          companyData: safeJSON(data.companyDataJson, {}),
          tenantId:      domain.split('.')[0],
          isPreview: false,
          
        });
      } catch (err) {
        console.error('Domain fetch failed:', err);
        // ⭐ REMOVED Template_1 fallback. If it fails, it stays null.
        setTenantData({ 
            templateReference: previewTemplate || null,
            companyId: null 
        });
      } finally {
        setLoading(false);
      }
    };

    fetchTenantData();
  }, []);

  return (
    <TenantContext.Provider value={{ tenantData, loading }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenant must be used inside TenantProvider');
  return ctx;
};

export default TenantContext;